var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowcalthShoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 28,
    fill: "#EEF0F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 48) rotate(-18 72 52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 84c10-15 25-25 45-30 10-3 19-9 26-18 5-7 11-8 17-3 8 7 18 11 31 12 9 1 16 8 17 17l1 13c1 6-4 11-10 11H25c-7 0-11-2-7-2Z",
    fill: "#FF6177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 84h126c7 0 11 7 7 13-3 4-8 7-14 7H18c-8 0-12-9-7-15 2-2 5-4 9-5Z",
    fill: "#F54E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 78c30 4 74 4 112-1",
    stroke: "#FFB4C0",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 54l6 11M72 48l6 12M86 40l6 12",
    stroke: "#4B5563",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 104h111",
    stroke: "#D9465C",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 112,
    r: 3,
    fill: "#D9465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 112,
    r: 3,
    fill: "#D9465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 112,
    r: 3,
    fill: "#D9465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 112,
    r: 3,
    fill: "#D9465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 3,
    fill: "#D9465C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowcalthShoe);
export default __webpack_public_path__ + "static/media/growcalth-shoe.f002d127c7558fb59ebb7264cbef2aba.svg";
export { ForwardRef as ReactComponent };